import { YotpoIcon } from '@yotpo-common/react-b2b-components/icon';
import React, { useState } from 'react';
import styled from 'styled-components'

const Wrapper = styled.div`
    position: relative;
    width: 100%;
    height: 672px;
    background: ${({ theme }) => theme.colors.background};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    overflow: hidden;
`;

const Container = styled.div<any>`
    position: absolute;
    height: 500px;
    width: 500px;
    left: ${({isActive, leftSide}) => isActive ? '50%' : (!leftSide ? '150%' : '-150%')};
    top: 50%;
    bottom: 50%;
    transition: all 0.2s;
    transform: translate(-50%, -50%);
    ${({isActive}) => isActive && `
        right: 50%;
    `};
`;

const ButtonsContainer = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 36px;
    width: 100%;
`;

const Dot = styled.div<any>`
    cursor: pointer;
    width: 10px;
    height: 10px;
    margin: 5px;
    border-radius: 50%;
    background-color: ${({ isActive, theme }) => (isActive ? theme.colors.primaryBlue : theme.colors.grayedOut)};

`;

const PrevButtonWrapper = styled.div`
    position: absolute;
    left: 68px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    cursor: pointer;
    background: #fff;
    box-shadow: 0px 0px 0px 1px #1C1D211F;
`;

const NextButtonWrapper = styled.div`
    position: absolute;
    right: 68px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    cursor: pointer;
    background: #fff;
    box-shadow: 0px 0px 0px 1px #1C1D211F;
`;

const PrevButton = ({handlePrev} : any) => {
    return (
        <PrevButtonWrapper onClick={handlePrev}>
            <YotpoIcon style={{width: '20px', height: '20px', color: 'black'}} name="chevron-left-big"></YotpoIcon>
        </PrevButtonWrapper>
    )
}

const NextButton = ({handleNext} : any) => {
    return (
        <NextButtonWrapper onClick={handleNext}>
            <YotpoIcon style={{width: '20px', height: '20px', color: 'black'}} name="chevron-right-big"></YotpoIcon>
        </NextButtonWrapper>
    )
}

const items = [
    <div style={{height: '100%', width: '100%', background: 'red'}}>1</div>,
    <div style={{height: '100%', width: '100%', background: 'blue'}}>2</div>,
    <div style={{height: '100%', width: '100%', background: 'green'}}>3</div>,
    <div style={{height: '100%', width: '100%', background: 'black'}}>4</div>,
    // <div style={{height: 300, width: 300, background: 'green'}}>3</div>
]

export const CarouselScreen = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex(currentIndex === 0 ? items.length - 1 : currentIndex - 1);
  };

  const handleNext = () => {
    setCurrentIndex(currentIndex === items.length - 1 ? 0 : currentIndex + 1);
  };

  return (
    <Wrapper>
      {items.map((item : any, index: number) => (
        <Container
            key={index}
            isActive={currentIndex === index}
            leftSide={index < currentIndex}
        >
          {item}
        </Container>
      ))}
      {currentIndex > 0 &&
        <PrevButton handlePrev={handlePrev}>
            Prev
        </PrevButton>
      }
      {currentIndex !== 3 &&
        <NextButton handleNext={handleNext}>
            Next
        </NextButton>
      }
      <ButtonsContainer>
        {items.map((_ : any, index: number) => (
          <Dot
            onClick={() => setCurrentIndex(index)}
            key={index}
            isActive={currentIndex === index}
          />
        ))}
      </ButtonsContainer>
    </Wrapper>
  );
};
